import { IntegrationIconProps } from './types';

const RLang = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 24.1429C22.732 24.1429 29 19.8576 29 14.5714C29 9.28527 22.732 5 15 5C7.26801 5 1 9.28527 1 14.5714C1 19.8576 7.26801 24.1429 15 24.1429ZM16.89 21.7142C22.6503 21.7142 27.32 19.8571 27.32 15.2142C27.32 10.5714 22.6503 8.71424 16.89 8.71424C11.1297 8.71424 6.45999 11.6244 6.45999 15.2142C6.45999 18.8041 11.1297 21.7142 16.89 21.7142Z"
      fill="url(#paint0_linear_1334_1710)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.7005 19.7143H22.2805L23.2251 20.0998C23.9724 20.4049 24.5939 20.9634 24.9848 21.6814L27.8805 27H22.5605L20.072 22.1754C19.8662 21.7764 19.5881 21.4207 19.2526 21.1272L19.095 20.9894C18.892 20.8119 18.6335 20.7143 18.3662 20.7143H17.2405V27H12.4805V10.9286L22.7005 10.876C24.5205 10.876 26.4805 12.8046 26.4805 15.2951C26.4805 17.7857 24.5205 19.7143 22.7005 19.7143ZM17.3805 14.4286L20.3205 14.4304C21.0225 14.4676 21.5805 15.0601 21.5805 15.7857C21.5805 16.5113 21.0225 17.1057 20.3205 17.1428H17.3805V14.4286Z"
      fill="url(#paint1_linear_1334_1710)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1334_1710"
        x1="3.87"
        y1="9.14286"
        x2="29.1096"
        y2="17.8242"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C8CBCD" />
        <stop offset="1" stopColor="#88888F" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1334_1710"
        x1="27.8805"
        y1="27"
        x2="9.79835"
        y2="11.8608"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#185DAC" />
        <stop offset="1" stopColor="#2F72C4" />
      </linearGradient>
    </defs>
  </svg>
);
export default RLang;
